const oneMegabyte = 1048576;

function bytesToMegabytes(bytes: number): number {
  return bytes / oneMegabyte;
}

export class PerformanceInfoProvider {
  /** Returns memory information in megabytes */
  getMemoryInfo(): { totalJSHeapSize: number; usedJSHeapSize: number; jsHeapSizeLimit: number } {
    const memoryInf = (window.performance as any).memory;
    
    if (!memoryInf) {
      return null;
    }

    return {
      totalJSHeapSize: bytesToMegabytes(memoryInf.totalJSHeapSize),
      usedJSHeapSize: bytesToMegabytes(memoryInf.usedJSHeapSize),
      jsHeapSizeLimit: bytesToMegabytes(memoryInf.jsHeapSizeLimit),
    };
  }
}
